import React, { useEffect, useState } from 'react'
import { facets } from '../../assets/data/search'
import { meiliSearchAPI } from '../../services/api/meilisearch';
import { topDriversChartsAPI } from '../../services/api/top-drivers-chart';
import DonutChart from './DonutChart';
import TopCallDrivers from './TopCallDrivers';
import styles from './styles.module.css'
import { getCookie } from '../../utils/common';


const Metrics = () => {
    
    const [facetsDistribution, setFacetsDistribution] = useState<any>({})
    const [isFacetsDistributionLoading, setIsFacetsDistributionLoading] = useState(true)

    const [isTopCallDriversLoading, setIsTopCallDriversLoading] = useState(true)
    const [topDriversData, setTopDriversData] = useState<any>({})

    const [emailCount, setEmailCount] = useState<number>(0)
    const [chatCount, setChatCount] = useState<number>(0)
    
    useEffect(() => {
        getFacetsDistribution()
        getTopCallDrivers()
    }, [])

    const getFacetsDistribution = () => {
        setIsFacetsDistributionLoading(true)

        const tenantSlug = getCookie('current_tenant')
        topDriversChartsAPI(tenantSlug).getSingle?.(`1`)
        .then((response) => {
            if(response?.communication_mode?.email) {
                setEmailCount(response.communication_mode.email)
            }
            if(response?.communication_mode?.chat) {
                setChatCount(response.communication_mode.chat)
            }
            setFacetsDistribution(response)
            setIsFacetsDistributionLoading(false)
        })
        .catch(err => {
            setIsFacetsDistributionLoading(false)
            console.log(err);
        })
    }

    const getTopCallDrivers = () => {
        const tenantSlug = getCookie('current_tenant')
        topDriversChartsAPI(tenantSlug).getSingle?.(`2`)
        .then(response => {
            setIsTopCallDriversLoading(false)
            setTopDriversData(response.chartData)
        })
        .catch(err => {
            setIsTopCallDriversLoading(false)
            console.log(err);
        })
    }

    return (
        <>
            {
                (!isFacetsDistributionLoading && !isTopCallDriversLoading) ?
                        <div className={`bg-white d-flex ${styles.container} p-2`}>
                            <div className="col-sm-4 p-2">
                                <DonutChart
                                    emails={emailCount}
                                    chats={chatCount}
                                />
                            </div>
                            <div className={`col-sm-8 p-2 ${styles.leftBorder}`}>
                                    <TopCallDrivers 
                                        data={topDriversData}
                                    />
                            </div>
                        </div>
                    :
                    null
            }
        </>
    )
}

export default Metrics
